export const TRAINING_STATUS = {
  NONE: 'none',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed'
};

export function filterByTrainingStatus(records, status) {
  return records.filter(r => r.trainingStatus === status);
}
